export default "__VITE_ASSET__Bzg$uO4V__"